interface LockRunButtonProps {
  isLocked: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export function LockRunButton({ isLocked, onToggle, disabled }: LockRunButtonProps) {
  return (
    <button
      onClick={onToggle}
      disabled={disabled}
      className={`px-4 py-2 border rounded flex items-center gap-2 ${
        disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-50'
      }`}
      title={isLocked ? 'Déverrouiller le run' : 'Verrouiller le run (protection)'}
    >
      <span className="text-lg">{isLocked ? '🔓' : '🔒'}</span>
      <span className="text-sm font-medium">
        {isLocked ? 'Déverrouiller' : 'Verrouiller'}
      </span>
    </button>
  );
}
